import React, { useEffect, useState } from 'react';
import { Activity, Brain, Zap, Check, X, AlertCircle, ShieldCheck, BookOpen, Clock, FileText, ChevronRight, ArrowRight } from 'lucide-react';
// --- META PIXEL HELPER ---
declare global {
  interface Window {
    fbq: any;
  }
}
const trackAddToCart = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Plan Vuelve a Funcionar 45+',
      content_type: 'product',
      value: 9300,
      currency: 'ARS'
    });
  }
};
// --- QUIZ DATA ---
const QUESTIONS = [{
  id: 1,
  question: '¿Qué te está pasando más seguido?',
  options: ['A veces funciona y a veces no', 'Arranca y se cae', 'En pareja falla más que solo', 'Estoy evitando intimidad']
}, {
  id: 2,
  question: '¿Qué es lo que más te complica en el momento?',
  options: ['Me apuro para "aprovechar"', 'Me quedo mirando si funciona', 'Me desconecto y hago chistes', 'Me da miedo que sea "para siempre"']
}, {
  id: 3,
  question: '¿Qué necesitás ahora mismo?',
  options: ['Un plan para esa noche (10 min)', 'Una rutina simple para recuperar base (21 días)', 'Saber qué ajustar primero', 'Cómo decirlo sin humillarme']
}];
// --- QUIZ COMPONENT ---
function Quiz({
  onComplete
}: {
  onComplete: () => void;
}) {
  const [step, setStep] = useState(0);
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const [showFinalCTA, setShowFinalCTA] = useState(false);
  const handleOptionClick = (index: number) => {
    if (selectedOption !== null) return;
    setSelectedOption(index);
    setTimeout(() => {
      if (step < QUESTIONS.length - 1) {
        setStep(step + 1);
        setSelectedOption(null);
      } else {
        setShowFinalCTA(true);
      }
    }, 400);
  };
  // Final CTA screen after completing quiz
  if (showFinalCTA) {
    return <div className="min-h-screen bg-[#111111] flex items-center justify-center p-6" data-id="element-0">
        <div className="max-w-md w-full" data-id="element-1">
          <div className="bg-[#1a1a1a] border border-white/10 rounded-2xl p-8 text-center shadow-2xl" data-id="element-2">
            <div className="w-16 h-16 bg-[#c41e3a]/20 text-[#c41e3a] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-3">
              <Check className="w-8 h-8" data-id="element-4" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2" data-id="element-5">
              Análisis completado
            </h2>
            <p className="text-gray-400 mb-8" data-id="element-6">
              Identificamos tu perfil. Tu plan de recuperación está listo.
            </p>

            <button onClick={onComplete} className="w-full bg-[#c41e3a] hover:bg-[#a01830] text-white font-bold py-4 px-6 rounded-lg text-lg transition-all transform hover:scale-[1.02] shadow-lg flex items-center justify-center gap-2 group" data-id="element-7">
              Ver el plan
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-8" />
            </button>

            <p className="mt-4 text-xs text-gray-500" data-id="element-9">
              Contenido educativo. No reemplaza consulta profesional.
            </p>
          </div>

          <button onClick={onComplete} className="w-full mt-6 text-sm text-gray-600 hover:text-gray-400 underline underline-offset-4 transition-colors" data-id="element-10">
            Saltar y ver la carta de ventas
          </button>
        </div>
      </div>;
  }
  const currentQuestion = QUESTIONS[step];
  return <div className="min-h-screen bg-[#111111] flex flex-col items-center justify-center p-6 relative" data-id="element-11">
      {/* Progress bar */}
      <div className="absolute top-0 left-0 w-full h-1 bg-[#1a1a1a]" data-id="element-12">
        <div className="h-full bg-[#c41e3a] transition-all duration-500 ease-out" style={{
        width: `${(step + 1) / QUESTIONS.length * 100}%`
      }} data-id="element-13" />
      </div>

      <div className="max-w-md w-full" data-id="element-14">
        {/* Header */}
        <div className="mb-8 text-center" data-id="element-15">
          <p className="text-[#c41e3a] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-16">
            Checklist rápido (20 segundos)
          </p>
          <p className="text-sm text-gray-500" data-id="element-17">
            Respondé rápido. Tus respuestas son privadas.
          </p>
        </div>

        {/* Question card */}
        <div className="bg-[#1a1a1a] border border-white/10 rounded-2xl p-6 md:p-8 shadow-2xl" data-id="element-18">
          <div className="flex justify-between items-center mb-6" data-id="element-19">
            <span className="text-xs font-medium text-gray-500" data-id="element-20">
              {step + 1} de {QUESTIONS.length}
            </span>
          </div>

          <h2 className="text-xl md:text-2xl font-bold text-white mb-8 leading-tight" data-id="element-21">
            {currentQuestion.question}
          </h2>

          <div className="space-y-3" data-id="element-22">
            {currentQuestion.options.map((option, idx) => <button key={idx} onClick={() => handleOptionClick(idx)} disabled={selectedOption !== null} className={`w-full text-left p-4 rounded-lg border transition-all duration-200 flex items-center justify-between group
                  ${selectedOption === idx ? 'border-[#c41e3a] bg-[#c41e3a]/20 text-white' : 'border-white/10 bg-[#111111] text-gray-300 hover:border-[#c41e3a]/50 hover:bg-[#c41e3a]/10 hover:text-white'}
                  ${selectedOption !== null && selectedOption !== idx ? 'opacity-50' : ''}
                `} data-id="element-23">
                <span data-id="element-24">{option}</span>
                <ChevronRight className={`w-4 h-4 transition-all ${selectedOption === idx ? 'opacity-100 text-[#c41e3a]' : 'opacity-0 group-hover:opacity-100 text-[#c41e3a]'}`} data-id="element-25" />
              </button>)}
          </div>
        </div>

        {/* Skip link */}
        <div className="mt-8 text-center" data-id="element-26">
          <button onClick={onComplete} className="text-sm text-gray-600 hover:text-gray-400 underline underline-offset-4 transition-colors" data-id="element-27">
            Saltar y ver la carta de ventas
          </button>
        </div>
      </div>
    </div>;
}
// --- SALES PAGE COMPONENT ---
function SalesPage() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#111111] text-gray-300 font-sans selection:bg-[#c41e3a] selection:text-white" data-id="element-28">
      {/* Navigation / Top Bar */}
      <nav className="w-full py-4 px-6 border-b border-white/10 bg-[#111111]/90 backdrop-blur fixed top-0 z-50" data-id="element-29">
        <div className="max-w-3xl mx-auto flex justify-between items-center" data-id="element-30">
          <div className="font-bold text-white tracking-tight" data-id="element-31">PVF 45+</div>
          <button onClick={scrollToPricing} className="text-sm font-medium text-white hover:text-[#c41e3a] transition-colors" data-id="element-32">
            Descargar Plan
          </button>
        </div>
      </nav>

      <main className="pt-20 pb-20" data-id="element-33">
        {/* HERO SECTION */}
        <section className="px-6 py-12 md:py-20 max-w-3xl mx-auto text-center" data-id="element-34">
          <div className="inline-block px-3 py-1 mb-6 border border-[#c41e3a]/30 rounded-full bg-[#c41e3a]/10 text-[#c41e3a] text-xs md:text-sm font-bold uppercase tracking-wider" data-id="element-35">
            Para hombres de 45 años o más
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-8" data-id="element-36">
            Si tenés 45+ y "a veces falla",{' '}
            <span className="text-[#c41e3a]" data-id="element-37">no estás roto</span>: estás
            improvisando
          </h1>

          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-gray-400 text-left md:text-center" data-id="element-38">
            <p data-id="element-39">
              No es que "no funcione". Es que{' '}
              <strong className="text-white" data-id="element-40">
                a veces funciona… y a veces no.
              </strong>
            </p>
            <p data-id="element-41">
              Y esa incertidumbre te está destruyendo por dentro. Porque cuando
              fallás, no falla solo el cuerpo:{' '}
              <span className="text-white border-b border-[#c41e3a]/50" data-id="element-42">
                falla el orgullo.
              </span>
            </p>
            <p data-id="element-43">
              Y a partir de ahí empezás a hacer lo peor posible:{' '}
              <strong data-id="element-44">improvisar en pánico.</strong>
            </p>
          </div>

          <div className="mt-12 p-6 bg-[#1a1a1a] rounded-xl border border-white/5 text-left" data-id="element-45">
            <p className="font-bold text-white mb-4" data-id="element-46">
              Este PDF es para hombres 45+ que están cansados de:
            </p>
            <ul className="space-y-3" data-id="element-47">
              <li className="flex items-start gap-3" data-id="element-48">
                <X className="w-5 h-5 text-[#c41e3a] shrink-0 mt-1" data-id="element-49" />
                <span data-id="element-50">Pensar "¿y si hoy también pasa?"</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-51">
                <X className="w-5 h-5 text-[#c41e3a] shrink-0 mt-1" data-id="element-52" />
                <span data-id="element-53">Evitar la intimidad para no exponerse</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-54">
                <X className="w-5 h-5 text-[#c41e3a] shrink-0 mt-1" data-id="element-55" />
                <span data-id="element-56">Probar trucos y quedar igual (o peor)</span>
              </li>
            </ul>
          </div>

          <div className="mt-10" data-id="element-57">
            <p className="text-lg font-medium text-white mb-8" data-id="element-58">
              Acá no hay pastillas. No hay promesas mágicas.
              <br data-id="element-59" />
              Hay un sistema simple para recuperar{' '}
              <span className="text-[#c41e3a]" data-id="element-60">control</span>.
            </p>

            <div className="relative group cursor-pointer" onClick={scrollToPricing} data-id="element-61">
              <div className="absolute -inset-1 bg-gradient-to-r from-[#c41e3a] to-red-900 rounded-lg blur opacity-25 group-hover:opacity-50 transition duration-200" data-id="element-62"></div>
              <button className="relative w-full md:w-auto bg-[#c41e3a] hover:bg-[#a01830] text-white font-bold py-4 px-8 rounded-lg text-lg transition-all transform active:scale-95 shadow-xl" data-id="element-63">
                Quiero recuperar el control
              </button>
            </div>
          </div>

          <div className="mt-16 relative" data-id="element-64">
            <div className="absolute inset-0 bg-gradient-to-t from-[#111111] via-transparent to-transparent z-10 h-full w-full" data-id="element-65"></div>
            <img src="https://cdn.magicpatterns.com/uploads/7G8EjgHW1S7f3KT3YNpd8h/heylloyd-image-1770147560066.png" alt="Plan Vuelve a Funcionar PDF en Tablet" className="w-full max-w-md mx-auto rounded-xl shadow-2xl border border-white/10 opacity-90" data-id="element-66" />
          </div>
        </section>

        {/* SECTION 2: EL MOMENTO */}
        <section className="px-6 py-16 bg-[#161616] border-y border-white/5" data-id="element-67">
          <div className="max-w-3xl mx-auto" data-id="element-68">
            <div className="flex items-center gap-3 mb-6" data-id="element-69">
              <AlertCircle className="text-[#c41e3a]" data-id="element-70" />
              <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-71">
                El momento
              </h2>
            </div>

            <p className="text-lg mb-8" data-id="element-72">
              Si estás leyendo esto, probablemente te pasó alguna de estas:
            </p>

            <div className="space-y-4 pl-4 border-l-2 border-[#c41e3a]/30" data-id="element-73">
              {['Estabas por tener sexo… y tu cuerpo no acompañó.', 'Se levantó… pero se cayó cuando cambiaste de posición.', 'Sentiste esa mirada (real o imaginaria) y te querías ir.', 'Te quedaste callado. Hiciste un chiste. Inventaste una excusa.', "Y después, solo, te pegó el pensamiento que nadie admite en voz alta: '¿Y si esto ya es así para siempre?'"].map((item, i) => <div key={i} className="text-gray-300 py-1" data-id="element-74">
                  {item}
                </div>)}
            </div>

            <p className="mt-10 text-xl font-medium text-white italic border-l-4 border-[#c41e3a] pl-6 py-2 bg-[#111111] rounded-r-lg" data-id="element-75">
              "No voy a decirte 'relajate'. Eso se lo dice alguien que no vive
              con el reloj en la cabeza."
            </p>
          </div>
        </section>

        {/* SECTION 3: THE TRIANGLE */}
        <section className="px-6 py-20 max-w-4xl mx-auto" data-id="element-76">
          <div className="text-center mb-12" data-id="element-77">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-78">
              La causa real
            </h2>
            <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-79">
              La mayoría cree que esto es una sola cosa: "circulación" o
              "estrés" o "edad". Pero el patrón real en hombres 45+ casi siempre
              es un combo:
            </p>
          </div>

          <div className="bg-[#1a1a1a] p-8 rounded-2xl border border-white/5 relative overflow-hidden" data-id="element-80">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#c41e3a]/5 rounded-full blur-3xl -mr-32 -mt-32" data-id="element-81"></div>

            <h3 className="text-2xl font-bold text-center text-white mb-10 tracking-widest uppercase" data-id="element-82">
              El Triángulo <span className="text-[#c41e3a]" data-id="element-83">3D</span>
            </h3>

            <div className="grid md:grid-cols-3 gap-8 relative z-10" data-id="element-84">
              <div className="flex flex-col items-center text-center p-4 rounded-xl" data-id="element-85">
                <div className="w-16 h-16 rounded-full bg-red-900/20 flex items-center justify-center mb-4 border border-red-900/30" data-id="element-86">
                  <Activity className="w-8 h-8 text-[#c41e3a]" data-id="element-87" />
                </div>
                <h4 className="text-xl font-bold text-white mb-2" data-id="element-88">SANGRE</h4>
                <p className="text-sm text-gray-400" data-id="element-89">
                  La base física mínima para llenado y sostén.
                </p>
              </div>

              <div className="flex flex-col items-center text-center p-4 rounded-xl" data-id="element-90">
                <div className="w-16 h-16 rounded-full bg-red-900/20 flex items-center justify-center mb-4 border border-red-900/30" data-id="element-91">
                  <Zap className="w-8 h-8 text-[#c41e3a]" data-id="element-92" />
                </div>
                <h4 className="text-xl font-bold text-white mb-2" data-id="element-93">NERVIO</h4>
                <p className="text-sm text-gray-400" data-id="element-94">
                  Sensibilidad y activación; cómo responde tu cuerpo al estímulo
                  real.
                </p>
              </div>

              <div className="flex flex-col items-center text-center p-4 rounded-xl" data-id="element-95">
                <div className="w-16 h-16 rounded-full bg-red-900/20 flex items-center justify-center mb-4 border border-red-900/30" data-id="element-96">
                  <Brain className="w-8 h-8 text-[#c41e3a]" data-id="element-97" />
                </div>
                <h4 className="text-xl font-bold text-white mb-2" data-id="element-98">CABEZA</h4>
                <p className="text-sm text-gray-400" data-id="element-99">
                  Ansiedad de rendimiento; el "monitor interno" que vigila y
                  mata el deseo.
                </p>
              </div>
            </div>

            <div className="mt-10 text-center border-t border-white/10 pt-8" data-id="element-100">
              <p className="text-lg text-white" data-id="element-101">
                Cuando una palanca baja, las otras dos empiezan a compensar…{' '}
                <br className="hidden md:block" data-id="element-102" />
                hasta que un día no pueden.{' '}
                <span className="text-[#c41e3a] font-bold" data-id="element-103">
                  Y ahí aparece la desesperación.
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* SECTION 4: WHY IT FAILED */}
        <section className="px-6 py-16 bg-[#161616] border-y border-white/5" data-id="element-104">
          <div className="max-w-3xl mx-auto" data-id="element-105">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-8" data-id="element-106">
              Por qué lo que probaste no sirvió
            </h2>

            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-107">
              <div data-id="element-108">
                <p className="mb-4" data-id="element-109">Probaste una o más:</p>
                <ul className="space-y-2 mb-6 text-gray-400" data-id="element-110">
                  <li className="flex items-center gap-2" data-id="element-111">
                    <div className="w-1.5 h-1.5 rounded-full bg-gray-600" data-id="element-112"></div>
                    Suplementos
                  </li>
                  <li className="flex items-center gap-2" data-id="element-113">
                    <div className="w-1.5 h-1.5 rounded-full bg-gray-600" data-id="element-114"></div>
                    Trucos de internet
                  </li>
                  <li className="flex items-center gap-2" data-id="element-115">
                    <div className="w-1.5 h-1.5 rounded-full bg-gray-600" data-id="element-116"></div>
                    Apurarte para "aprovechar"
                  </li>
                  <li className="flex items-center gap-2" data-id="element-117">
                    <div className="w-1.5 h-1.5 rounded-full bg-gray-600" data-id="element-118"></div>
                    Alcohol para "soltar"
                  </li>
                  <li className="flex items-center gap-2" data-id="element-119">
                    <div className="w-1.5 h-1.5 rounded-full bg-gray-600" data-id="element-120"></div>
                    Evitar el tema y rezar
                  </li>
                </ul>
              </div>

              <div className="bg-[#111111] p-6 rounded-lg border border-[#c41e3a]/20 shadow-lg" data-id="element-121">
                <h3 className="text-[#c41e3a] font-bold mb-3 uppercase tracking-wide text-sm" data-id="element-122">
                  El Problema
                </h3>
                <p className="text-white font-medium mb-4" data-id="element-123">
                  Todo eso es <span className="italic" data-id="element-124">reacción</span>, no
                  sistema.
                </p>
                <p className="text-sm text-gray-400" data-id="element-125">
                  Y si reaccionás en el momento del acto, ya llegaste tarde.
                  Porque ahí la vergüenza ya está sentada en la cama con vos.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 5: THE PROMISE */}
        <section className="px-6 py-20 max-w-3xl mx-auto text-center" data-id="element-126">
          <h2 className="text-3xl font-bold text-white mb-8" data-id="element-127">
            La promesa real
          </h2>
          <div className="text-xl leading-relaxed space-y-6" data-id="element-128">
            <p data-id="element-129">Este plan no promete convertirte en actor porno.</p>
            <p className="text-white font-medium" data-id="element-130">
              Promete algo mejor para un hombre desesperado:
            </p>
            <div className="inline-block text-left bg-[#1a1a1a] p-8 rounded-xl border border-white/10 shadow-2xl" data-id="element-131">
              <ul className="space-y-4" data-id="element-132">
                <li className="flex items-center gap-4" data-id="element-133">
                  <Check className="w-6 h-6 text-[#c41e3a]" data-id="element-134" />
                  <span className="text-white text-lg" data-id="element-135">
                    Dejar de entrar en pánico.
                  </span>
                </li>
                <li className="flex items-center gap-4" data-id="element-136">
                  <Check className="w-6 h-6 text-[#c41e3a]" data-id="element-137" />
                  <span className="text-white text-lg" data-id="element-138">
                    Volver a tener un plan.
                  </span>
                </li>
                <li className="flex items-center gap-4" data-id="element-139">
                  <Check className="w-6 h-6 text-[#c41e3a]" data-id="element-140" />
                  <span className="text-white text-lg" data-id="element-141">
                    Mejorar la consistencia trabajando las 3 palancas.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* SECTION 6: WHAT IT IS / IS NOT */}
        <section className="px-6 py-16 bg-[#161616] border-y border-white/5" data-id="element-142">
          <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-143">
            <div className="bg-[#111111] p-8 rounded-xl border border-[#c41e3a]/20" data-id="element-144">
              <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2" data-id="element-145">
                <ShieldCheck className="text-[#c41e3a]" data-id="element-146" /> ESTO ES:
              </h3>
              <ul className="space-y-4" data-id="element-147">
                {['Un PDF práctico de 21 días', 'Con rutina diaria (12–20 minutos)', 'Protocolo de Emergencia de 10 minutos', 'Checklists imprimibles', 'Guiones cortos para conversación'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-148">
                    <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-149" />
                    <span className="text-gray-300" data-id="element-150">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-[#1a1a1a] p-8 rounded-xl border border-white/5 opacity-80" data-id="element-151">
              <h3 className="text-xl font-bold text-gray-400 mb-6 flex items-center gap-2" data-id="element-152">
                <X className="text-gray-500" data-id="element-153" /> ESTO NO ES:
              </h3>
              <ul className="space-y-4" data-id="element-154">
                {['Terapia eterna', "Una promesa de 'cura'", 'Un curso médico', 'Pastillas'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-155">
                    <X className="w-5 h-5 text-gray-500 shrink-0 mt-0.5" data-id="element-156" />
                    <span className="text-gray-400" data-id="element-157">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </section>

        {/* SECTION 7: RESULTS */}
        <section className="px-6 py-20 max-w-3xl mx-auto" data-id="element-158">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-159">
            Lo que vas a notar primero
          </h2>
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#111111] p-8 rounded-2xl border border-white/10" data-id="element-160">
            <p className="text-[#c41e3a] font-bold text-sm uppercase tracking-wider mb-6" data-id="element-161">
              En los primeros 7–10 días
            </p>
            <div className="grid sm:grid-cols-2 gap-6 mb-8" data-id="element-162">
              <div className="flex items-start gap-3" data-id="element-163">
                <div className="w-2 h-2 rounded-full bg-[#c41e3a] mt-2" data-id="element-164"></div>
                <p data-id="element-165">Menos miedo anticipatorio</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-166">
                <div className="w-2 h-2 rounded-full bg-[#c41e3a] mt-2" data-id="element-167"></div>
                <p data-id="element-168">Más control del ritmo y del cuerpo</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-169">
                <div className="w-2 h-2 rounded-full bg-[#c41e3a] mt-2" data-id="element-170"></div>
                <p data-id="element-171">Menos necesidad de "testear"</p>
              </div>
              <div className="flex items-start gap-3" data-id="element-172">
                <div className="w-2 h-2 rounded-full bg-[#c41e3a] mt-2" data-id="element-173"></div>
                <p data-id="element-174">Más presencia (sin estar mirando si funciona)</p>
              </div>
            </div>
            <p className="text-center text-white font-medium border-t border-white/10 pt-6" data-id="element-175">
              Lo físico se construye con consistencia. <br data-id="element-176" />
              <span className="text-[#c41e3a]" data-id="element-177">
                La cabeza se calma cuando deja de improvisar.
              </span>
            </p>
          </div>
        </section>

        {/* SECTION 8: DELIVERABLES */}
        <section className="px-6 py-16 bg-[#161616] border-y border-white/5" data-id="element-178">
          <div className="max-w-4xl mx-auto" data-id="element-179">
            <h2 className="text-3xl font-bold text-white mb-10 text-center" data-id="element-180">
              Qué incluye
            </h2>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-181">
              <div className="bg-[#111111] p-6 rounded-lg border border-white/10 flex items-start gap-4" data-id="element-182">
                <BookOpen className="w-8 h-8 text-[#c41e3a] shrink-0" data-id="element-183" />
                <div data-id="element-184">
                  <h3 className="font-bold text-white text-lg" data-id="element-185">
                    Plan "Vuelve a Funcionar" (45+)
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-186">
                    PDF principal con el sistema completo
                  </p>
                </div>
              </div>

              <div className="bg-[#111111] p-6 rounded-lg border border-white/10 flex items-start gap-4" data-id="element-187">
                <Check className="w-8 h-8 text-[#c41e3a] shrink-0" data-id="element-188" />
                <div data-id="element-189">
                  <h3 className="font-bold text-white text-lg" data-id="element-190">
                    Checklist Diario 21 días
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-191">
                    Para seguimiento simple y rápido
                  </p>
                </div>
              </div>

              <div className="bg-[#111111] p-6 rounded-lg border border-white/10 flex items-start gap-4" data-id="element-192">
                <Clock className="w-8 h-8 text-[#c41e3a] shrink-0" data-id="element-193" />
                <div data-id="element-194">
                  <h3 className="font-bold text-white text-lg" data-id="element-195">
                    Protocolo Emergencia 10'
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-196">
                    Qué hacer cuando no responde (sin desaparecer)
                  </p>
                </div>
              </div>

              <div className="bg-[#111111] p-6 rounded-lg border border-white/10 flex items-start gap-4" data-id="element-197">
                <FileText className="w-8 h-8 text-[#c41e3a] shrink-0" data-id="element-198" />
                <div data-id="element-199">
                  <h3 className="font-bold text-white text-lg" data-id="element-200">
                    Guiones de conversación
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-201">
                    Qué decir en 20s, 60s o si te pegó en el ego
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 9: AUDIENCE */}
        <section className="px-6 py-20 max-w-3xl mx-auto" data-id="element-202">
          <div className="bg-[#1a1a1a] rounded-2xl overflow-hidden border border-white/10" data-id="element-203">
            <div className="grid md:grid-cols-2" data-id="element-204">
              <div className="p-8 border-b md:border-b-0 md:border-r border-white/10" data-id="element-205">
                <h3 className="text-white font-bold mb-6" data-id="element-206">
                  Esto es para vos si:
                </h3>
                <ul className="space-y-3 text-sm" data-id="element-207">
                  <li className="flex items-start gap-2" data-id="element-208">
                    <Check className="w-4 h-4 text-green-500 mt-1" data-id="element-209" />
                    <span data-id="element-210">Tenés 45+ años</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-211">
                    <Check className="w-4 h-4 text-green-500 mt-1" data-id="element-212" />
                    <span data-id="element-213">Te pasa "a veces" o más seguido</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-214">
                    <Check className="w-4 h-4 text-green-500 mt-1" data-id="element-215" />
                    <span data-id="element-216">Te importa tu pareja y tu orgullo</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-217">
                    <Check className="w-4 h-4 text-green-500 mt-1" data-id="element-218" />
                    <span data-id="element-219">Querés una solución sin humillarte</span>
                  </li>
                </ul>
              </div>
              <div className="p-8 bg-[#111111]" data-id="element-220">
                <h3 className="text-gray-400 font-bold mb-6" data-id="element-221">
                  No es para vos si:
                </h3>
                <ul className="space-y-3 text-sm text-gray-500" data-id="element-222">
                  <li className="flex items-start gap-2" data-id="element-223">
                    <X className="w-4 h-4 mt-1" data-id="element-224" />
                    <span data-id="element-225">Querés una promesa milagrosa</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-226">
                    <X className="w-4 h-4 mt-1" data-id="element-227" />
                    <span data-id="element-228">Querés seguir improvisando</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-229">
                    <X className="w-4 h-4 mt-1" data-id="element-230" />
                    <span data-id="element-231">Buscás culpar a la suerte</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 10: PRICING & CTA */}
        <section id="pricing" className="px-6 py-20 bg-gradient-to-b from-[#111111] to-[#1a1a1a] border-t border-white/5" data-id="element-232">
          <div className="max-w-lg mx-auto text-center" data-id="element-233">
            <h2 className="text-3xl font-bold text-white mb-4" data-id="element-234">
              Dejá de improvisar
            </h2>
            <p className="text-gray-400 mb-10" data-id="element-235">
              Si querés dejar de rezar y volver a tener un plan, descargalo
              ahora.
            </p>

            <div className="bg-[#111111] p-1 rounded-2xl border border-[#c41e3a]/30 shadow-[0_0_40px_rgba(196,30,58,0.1)]" data-id="element-236">
              <div className="bg-[#161616] rounded-xl p-8 md:p-12 relative overflow-hidden" data-id="element-237">
                <div className="absolute top-0 right-0 bg-[#c41e3a] text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-238">
                  OFERTA ESPECIAL
                </div>

                <div className="mb-8" data-id="element-239">
                  <div className="flex items-center justify-center gap-3 mb-2" data-id="element-240">
                    <span className="text-2xl text-gray-500 line-through" data-id="element-241">
                      $14.900
                    </span>
                    <span className="bg-[#c41e3a] text-white text-xs font-bold px-2 py-1 rounded" data-id="element-242">
                      -37%
                    </span>
                  </div>
                  <span className="text-5xl font-bold text-white" data-id="element-243">$9.300</span>
                  <span className="text-gray-500 ml-2" data-id="element-244">ARS</span>
                </div>

                <div className="space-y-4 mb-8 text-left" data-id="element-245">
                  <div className="flex items-center gap-3 text-sm text-gray-300" data-id="element-246">
                    <Check className="w-4 h-4 text-[#c41e3a]" data-id="element-247" />
                    <span data-id="element-248">Acceso inmediato al PDF</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-gray-300" data-id="element-249">
                    <Check className="w-4 h-4 text-[#c41e3a]" data-id="element-250" />
                    <span data-id="element-251">Todos los checklists imprimibles</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-gray-300" data-id="element-252">
                    <Check className="w-4 h-4 text-[#c41e3a]" data-id="element-253" />
                    <span data-id="element-254">Protocolo de Emergencia incluido</span>
                  </div>
                </div>

                <a href="https://argrutinas.com/cart/42961602969809:1" onClick={trackAddToCart} className="w-full bg-[#c41e3a] hover:bg-[#a01830] text-white font-bold py-4 px-6 rounded-lg text-lg transition-all transform hover:scale-[1.02] shadow-lg mb-4 block text-center" data-id="element-255">
                  Quiero el Plan de 21 días
                </a>

                <p className="text-xs text-gray-500 flex items-center justify-center gap-2" data-id="element-256">
                  <ShieldCheck className="w-3 h-3" data-id="element-257" /> Compra segura y discreta
                </p>
              </div>
            </div>

            <div className="mt-12 opacity-50 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-258">
              <img src="https://cdn.magicpatterns.com/uploads/7G8EjgHW1S7f3KT3YNpd8h/heylloyd-image-1770147560066.png" alt="Product Preview" className="w-32 mx-auto" data-id="element-259" />
            </div>
          </div>
        </section>

        <footer className="py-12 text-center text-gray-600 text-sm border-t border-white/5 bg-[#0f0f0f]" data-id="element-260">
          <p data-id="element-261">© 2024 Plan Vuelve a Funcionar. Todos los derechos reservados.</p>
          <p className="mt-2" data-id="element-262">
            Este producto es una guía informativa y no sustituye consejo médico
            profesional.
          </p>
        </footer>
      </main>
    </div>;
}
// --- MAIN APP COMPONENT ---
export function App() {
  const [showQuiz, setShowQuiz] = useState(true);
  if (showQuiz) {
    return <Quiz onComplete={() => setShowQuiz(false)} data-id="element-263" />;
  }
  return <SalesPage data-id="element-264" />;
}